<template>
  <div class="video-overlay-wrapper">
    <div :class="[{'video-overlay': active}]">
      <div class="video-overlay-white"></div>
      <slot></slot>
    </div>

    <div class="overlay-content-wrapper" v-if="active">
      <div class="overlay-content">
        Aktuálne nemáte prístup pre prehratie videí z tejto témy. V&nbsp;prípade
        Vášho záujmu pre pozretie videí z tejto témy nám prosím dajte vedieť
        a&nbsp;kliknite na tlačidlo Mám záujem.
        <a
          class="button"
          @click="modal"
        >Mám záujem</a>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.video-overlay-wrapper {
  position: relative;
  overflow: hidden;
}

.video-overlay {
  filter: blur(9px);

  .video-overlay-white {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
  }
}

.overlay-content-wrapper {
  position: absolute;
  top: 0;

  width: 100%;
  height: 100%;

  display: flex;

  align-items: center;
  justify-content: center;
}

.overlay-content {
  width: 30em;
  max-width: 100%;
  text-align: center;

  font-size: 15px;
  text-align: center;
  font-weight: bold;

  .button {
    display: block;
    margin: 2em auto;
    width: 9em;
  }
}

@media screen and (min-width: 500px) {
  .overlay-content {
    // margin: 10% auto;
    font-size: 11px;
  }
}
</style>

<script>
export default {
  props: ["id", "active"],
  methods: {
    modal() {
      const $this = this;

      this.$api.server
        .post("api/public/video-groups/request-access", {
          id: this.id
        })
        .then(r => {
          this.$api.bus.trigger("open-modal", {
            header: "Ďakujeme za Váš záujem",
            message:
              "Vašu požiadavku budeme konzultovať so zástupcom Vašej spoločnosti a o ďalšom postupe Vás budeme informovať. Tím Maxman Consultants",
            okBtn: "Zavrieť",
            closeBtn: "Zavrieť",
            hideCloseBtn: true,
            cb() {
              //$this.active = false;
            }
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoPlayerOverlay.vue